import { defineStore } from 'pinia'
import { mande } from 'mande'
import type { MandeError } from 'mande'
import { useI18n } from 'vue-i18n'

const api = mande('https://web.maximus.team/')

interface User {
  info: {
    email: string | null
    name: string | null
    mobile: string | null
  }
  isAuthenticated: boolean
  token: string | null
}

export const useUserStore = defineStore('user', {
  state: () => ({
    user: {
      info: {
        email: null,
        name: null,
        mobile: null,
      },
      isAuthenticated: false,
      token: null,
    } as User,
    /* user: {
      info: {
        email: 'toturkmen@gmail.com',
        name: 'Tolga Türkmen',
        mobile: '0 (532) 000 00 24',
      },
      isAuthenticated: true,
      token: 'test-token-123456',
    } as User, */
  }),

  actions: {
    async fetchUser() {
      try {
        const token = document.cookie
          .split('; ')
          .find((row) => row.startsWith('auth_token='))
          ?.split('=')[1]
        if (!token) return false

        const response = await api.get<any>('user', {
          headers: {
            'Accept-Language': useI18n().locale.value.split('-')[0],
            Authorization: `${token}`,
            'Pragma-Cache-Local': '1231231231231',
          },
        })

        this.user.info.email = response.payload.info.email
        this.user.info.name = response.payload.info.name
        this.user.info.mobile = response.payload.info.mobile
        this.user.isAuthenticated = true
        this.user.token = token
      } catch (error) {}
    },
  },
})
